module.exports = __webpack_public_path__ + "img/dexfreedom-logo.00906599.svg";